Vue.asyncComponent('bp-blueprint-editor-view-settings', {
    props: {
        showGuides: {
            type: Boolean
        },
        dataProvider: {
            type: Object,
            required: true
        },
        showHiddenElements: {
            type: Boolean,
        },
        breakpoint: {
            type: Object,
        }
    },
    computed: {
        amountOfHiddenElements() {
            if(! this.breakpoint) {
                return null;
            }

            return this.breakpoint.blockPositioning.filter(breakpoint => breakpoint.hidden).length;
        },
        descriptionToggleHidden() {
            if (this.showHiddenElements) {
                return this.$t('Verberg de elementen die momenteel<br> verborgen zijn op @breakpoint-name', {'@breakpoint-name': this.breakpoint.title});
            }

            return this.amountOfHiddenElements ?
                this.$t('Toon de elementen die momenteel<br> verborgen zijn op @breakpoint-name', {'@breakpoint-name': this.breakpoint.title}):
                this.$t('Er zijn momenteel nog geen elementen<br> verborgen op @breakpoint-name. Tip: Je kan de<br> optie “Verbergen” activeren via het<br> contextueel menu van elk element.', {'@breakpoint-name': this.breakpoint.title});
        }
    }

}, 'blueprints/editor/bp-blueprint-editor-view-settings.html');